export const FIRST_MILE_DASHBOARD_CRITERIA = 123
export const MIDDLE_MILE_DASHBOARD_CRITERIA = 122
export const ADMIN_LOAD_TRACKING_CRITERIA = 7
